import { Constants } from "@constants";
import { createSlice } from "@reduxjs/toolkit";
import apiService from "@utils/apiService";
import { verifyApiResponse } from "@utils/apiResponseHelper";

const {
  MY_ASSESSMENTS_KEY,
} = Constants.MULTI_DASHBOARD;

const initialState = {
  loading: false,
  error: false,
  scorecards: [],
};

export const multiScorecardSlice = createSlice({
  name: "multiScorecard",
  initialState,
  reducers: {
    multiScorecardStart: (state) => ({
      ...state,
      loading: true,
      error: false,
    }),
    multiScorecardSuccess: (state, action) => ({
      ...state,
      loading: false,
      error: false,
      scorecards: action.payload,
    }),
    multiScorecardFailure: (state) => ({
      ...state,
      loading: false,
      error: true,
    }),
  },
});

export const {
  multiScorecardStart,
  multiScorecardSuccess,
  multiScorecardFailure,
} = multiScorecardSlice.actions;

export const getMultiScorecardsInfo = () => (dispatch) => {
  dispatch(multiScorecardStart());
  apiService.get(Constants.API.SCORE_CARD).then((response) => {
    let data = verifyApiResponse(response);
    if (data?.systemMessage?.success) {
      dispatch(multiScorecardSuccess(data?.data));
    } else {
      dispatch(multiScorecardFailure());
    }
  }).catch(() => {
    dispatch(multiScorecardFailure());
  })
};

export default multiScorecardSlice.reducer;
